module.exports = __webpack_public_path__ + "static/media/asset15.8f395220.png";